import { render, staticRenderFns } from "./AgendaForm.vue?vue&type=template&id=9fd80516&scoped=true&"
import script from "./AgendaForm.vue?vue&type=script&lang=js&"
export * from "./AgendaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd80516",
  null
  
)

export default component.exports